export default __webpack_public_path__ + "static/media/prospectusers.40fbf8b5.svg";